import Vue from 'vue'
import VueRouter from 'vue-router'
// 引入修改后的组件名
import LoginPage from '../views/LoginPage.vue'
import ChatLayout from '../views/ChatLayout.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/login' // 默认跳转到登录页
    },
    {
        path: '/login',
        name: 'Login', // 路由名称可以保持，但组件名建议双词
        component: LoginPage // 使用修改后的组件名
    },
    {
        path: '/chat',
        name: 'Chat',
        component: ChatLayout,
        meta: { requiresAuth: true } // 标记需要登录
    }
]

const router = new VueRouter({
    // mode: 'history', // 可以使用 history 模式，需要后端配置
    base: process.env.BASE_URL,
    routes
})

// 简单的导航守卫，检查登录状态
router.beforeEach((to, from, next) => {
    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'; // 使用 localStorage 模拟登录状态

    if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
        // 需要登录但未登录，跳转到登录页
        next('/login');
    } else if (to.name === 'Login' && isLoggedIn) {
        // 已登录但尝试访问登录页，跳转到聊天页
        next('/chat');
    } else {
        // 其他情况正常跳转
        next();
    }
});


export default router
